import { createTheme } from '@mui/material';
import { responsiveFontSizes } from '@mui/material';

const createAppTheme = (direction) =>
  responsiveFontSizes(
    createTheme({
      palette: {
        primary: {
          main: '#00B8E0',
          light: 'rgba(160, 244, 255, 0.42)'
        },
        secondary: {
          main: '#00E2C7'
        },
        common: {
          white: '#fefefe',
          black: '#1a1a1a'
        },
        success: {
          main: '#00dd88'
        },
        accept: {
          main: '#00dd88'
        },
        deny: {
          main: '#ff4411'
        },
        error: {
          main: '#ff4411'
        },
        info: {
          main: '#00ccff'
        },
        warning: {
          main: '#ffbb00'
        },
        grey: {
          main: '#989898',
          light: '#cacaca'
        }
      },
      components: {
        MuiTextField: {
          defaultProps: {
            color: 'primary',
            variant: 'filled',
            InputProps: {
              disableUnderline: true
            }
          },
          styleOverrides: {
            root: ({ theme, ownerState }) => ({
              margin: 0,
              '.MuiFilledInput-root': {
                borderRadius: theme.shape.borderRadius,
                backgroundColor: theme.palette.background.paper,

                border: `1px solid ${theme.palette.primary.light}`,

                '&:hover': {
                  backgroundColor: theme.palette.background.paper
                },

                '&.Mui-focused': {
                  backgroundColor: theme.palette.background.paper,
                  border: `1px solid ${theme.palette.secondary.main}`,
                  boxShadow: theme.shadows[1]
                },

                '&.Mui-error': {
                  border: `1px solid ${theme.palette.error.main}`
                },

                textarea: {
                  resize: 'vertical'
                },

                // under rtl, stylis-plugin-rtl flips this value back
                input: {
                  direction: `${
                    ownerState.ltr && theme.direction === 'rtl' ? 'rtl' : 'ltr'
                  } !important`
                }
              },

              '.MuiFormLabel-root': {
                color: theme.palette.primary.main,
                '&.Mui-focused': {
                  color: theme.palette.secondary.main
                }
              }
            })
          }
        },
        MuiButton: {
          variants: [
            {
              props: { size: 'small' },
              style: {
                fontSize: 14,
                height: 32
              }
            },
            {
              props: { variant: 'outlined' },
              style: ({ theme }) => ({
                color: theme.palette.primary.main,
                borderStyle: 'solid',
                borderWidth: 2
              })
            },

            {
              props: { variant: 'gradient' },
              style: ({ theme }) => ({
                color: theme.palette.getContrastText(
                  theme.palette.secondary.main
                ),
                background: `linear-gradient(50deg, ${theme.palette.primary.main} 30%, ${theme.palette.secondary.main})`,
                transition: 'ease .3s',
                borderRadius: 50,
                fontSize: 16,
                height: 48,
                width: '100%',
                '&:hover': {
                  background: `linear-gradient(50deg, ${theme.palette.primary.main} 30%, ${theme.palette.secondary.main})`
                }
              })
            },
            {
              props: { solo: true },
              style: {
                height: 60,
                maxWidth: 60,
                minWidth: 60,
                width: 60
              }
            }
          ]
        }
      },
      direction,
      shape: {
        borderRadius: 8
      },
      shadows: ['none', '0 0 8px 0 #0003'],

      typography: {
        button: {
          fontSize: 16,
          height: 48,
          // persian has no case; keeps english labels as written
          textTransform: 'none'
        }
      }
    })
  );

const themes = {
  rtl: createAppTheme('rtl'),
  ltr: createAppTheme('ltr')
};

export const getTheme = (direction) => themes[direction] || themes.rtl;

export default themes.rtl;
